/**
 * Попап для просмотра видеовизитки психолога
 */
var VideoPopup = {
	init: function() {
		document.querySelectorAll('.psy-profile__video').forEach(function(btn) {
			btn.addEventListener('click', function() {
				VideoPopup.open(this.getAttribute('data-video'));
			});
		});

		var popup = document.getElementById('popup-video');
		if (popup) {
			popup.addEventListener('click', function(e) {
				if (e.target === popup || e.target.classList.contains('popup__wrapper')) {
					VideoPopup.close();
				}
			});
		}

		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape' && popup && popup.classList.contains('active')) {
				VideoPopup.close();
			}
		});
	},

	open: function(src) {
		var popup = document.getElementById('popup-video');
		var player = document.getElementById('popup-video-player');
		if (!popup || !player || !src) return;

		player.src = src;
		popup.classList.add('active');
		document.body.style.overflow = 'hidden';
		player.play().catch(function() {});
	},

	close: function() {
		var popup = document.getElementById('popup-video');
		var player = document.getElementById('popup-video-player');
		if (popup) {
			popup.classList.remove('active');
		}
		if (player) {
			player.pause();
			player.removeAttribute('src');
			player.load();
		}
		document.body.style.overflow = '';
	}
};

document.addEventListener('DOMContentLoaded', function() {
	VideoPopup.init();
});

window.VideoPopup = VideoPopup;
